// extracted by mini-css-extract-plugin
export default {"card_modal_box":"CardModal_card_modal_box__lvV5e"};